import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './ContentLayout.css';

export interface RelatedLink {
  to: string;
  label: string;
}

interface ContentLayoutProps {
  children: React.ReactNode;
  related: RelatedLink[];
}

const ContentLayout: React.FC<ContentLayoutProps> = ({ children, related }) => {
  // Content pages default to dark to match the app
  useEffect(() => {
    if (!document.documentElement.getAttribute('data-theme')) {
      document.documentElement.setAttribute('data-theme', 'dark');
    }
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="content-page">
      <header className="content-nav">
        <Link to="/" className="content-nav-brand">
          JSON ↔ TOON
        </Link>
        <nav className="content-nav-links" aria-label="Site">
          <Link to="/">Converter</Link>
          <Link to="/what-is-toon">What is TOON</Link>
          <Link to="/json-vs-toon">JSON vs TOON</Link>
          <Link to="/toon-format-spec">Format Spec</Link>
          <Link to="/reduce-llm-token-costs">Cut LLM Costs</Link>
        </nav>
      </header>

      <article className="content-article">{children}</article>

      <aside className="content-related" aria-label="Related reading">
        <h2>Keep reading</h2>
        <ul>
          {related.map((r) => (
            <li key={r.to}>
              <Link to={r.to}>{r.label}</Link>
            </li>
          ))}
        </ul>
        <div className="content-cta">
          <p>See the savings on your own data — paste JSON, get TOON, count the tokens.</p>
          <Link to="/" className="content-cta-button">
            Open the free converter
          </Link>
        </div>
      </aside>

      <footer className="content-footer">
        <p>
          Built for developers who care about performance and cost optimization
        </p>
      </footer>
    </div>
  );
};

export default ContentLayout;
